import React from "react";
import { string } from "prop-types";

const RightArrow = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32">
    <path
      fill={color || "#d60000"}
      d="M9.224,17.776c-0.14-0.175-0.214-0.368-0.223-0.578c-0.009-0.21,0.066-0.394,0.223-0.551l4.621-4.621
	L9.198,7.379c-0.14-0.14-0.206-0.328-0.197-0.564S9.084,6.39,9.224,6.25c0.175-0.175,0.363-0.258,0.564-0.249
	c0.201,0.009,0.381,0.092,0.538,0.249l5.225,5.225c0.087,0.087,0.149,0.175,0.184,0.262s0.052,0.184,0.052,0.289
	c0,0.105-0.017,0.201-0.052,0.289c-0.035,0.088-0.096,0.175-0.184,0.263l-5.199,5.199c-0.157,0.158-0.341,0.232-0.551,0.223
	C9.592,17.991,9.399,17.916,9.224,17.776z"
    />
  </svg>
);

RightArrow.propTypes = {
  color: string,
};

export default RightArrow;
